import React from 'react';
import './Loader.css';

const Loader = ({ small = false }) => {
  return (
    <div className={small ? "mini-loader-wrap" : "loader-container-center"}>
      <div className={small ? "spinner-small" : "premium-spinner"}></div>
    </div>
  );
};

export default Loader;